<template>
  <section class="video-testimonials py-5 bg-light-gray">
    <div class="container text-center">
      <div class="row justify-content-center mb-4">
        <div class="col-lg-8">
          <span
            class="badge badge-primary-base px-3 py-2 text-uppercase
              font-weight-bold mb-2"
          >
            ⭐ Testimonios Verificados
          </span>
          <h2 class="h1 font-weight-bold text-dark-blue mb-3">
            Lo que dicen los médicos que ya usan AMII
          </h2>
          <p class="lead text-muted">
            Colegas de distintas especialidades comparten cómo
            transformaron la gestión de su consulta y recuperaron su tiempo.
          </p>
        </div>
      </div>

      <!-- Instagram Reels Embeds -->
      <div class="row justify-content-center align-items-start">
        <div
          v-for="(testimonial, idx) in testimonials"
          :key="idx"
          class="col-12 col-md-6 col-lg-4 mb-4 scroll-reveal"
          :class="`delay-${idx}`"
        >
          <blockquote
            class="instagram-media"
            :data-instgrm-permalink="testimonial.permalink"
            data-instgrm-version="14"
          >
            <a
              :href="testimonial.permalink"
              target="_blank"
              rel="noopener noreferrer"
            >
              Ver testimonio en Instagram
            </a>
          </blockquote>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
const INSTAGRAM_EMBED_SRC = 'https://www.instagram.com/embed.js';

export default {
  name: 'VideoTestimonials',
  data() {
    return {
      // Para agregar más testimonios, suma objetos con el `permalink`
      // del Reel de Instagram.
      testimonials: [
        {
          permalink: 'https://www.instagram.com/reel/DXNg-aBgPbv/',
        },
        {
          permalink: 'https://www.instagram.com/reel/DYsmsKCyuOz/',
        },
        {
          permalink: 'https://www.instagram.com/reel/DURi-0Dju2d/',
        },
      ],
    };
  },
  mounted() {
    this.loadInstagramEmbed();
    this.initScrollObserver();
  },
  methods: {
    loadInstagramEmbed() {
      if (typeof window === 'undefined') return;
      if (window.instgrm && window.instgrm.Embeds) {
        this.$nextTick(() => window.instgrm.Embeds.process());
        return;
      }
      const existing = document.querySelector(
          `script[src="${INSTAGRAM_EMBED_SRC}"]`,
      );
      if (existing) {
        existing.addEventListener('load', this.processEmbeds);
        return;
      }
      const script = document.createElement('script');
      script.async = true;
      script.src = INSTAGRAM_EMBED_SRC;
      script.addEventListener('load', this.processEmbeds);
      document.body.appendChild(script);
    },
    processEmbeds() {
      if (window.instgrm && window.instgrm.Embeds) {
        this.$nextTick(() => window.instgrm.Embeds.process());
      }
    },
    initScrollObserver() {
      if (
        typeof window === 'undefined'
        || !('IntersectionObserver' in window)
      ) {
        return;
      }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          }
        });
      }, {threshold: 0.15});

      this.$el.querySelectorAll('.scroll-reveal')
          .forEach((el) => observer.observe(el));
    },
  },
};
</script>

<style scoped>
.text-dark-blue {
  color: #002196;
}
.scroll-reveal {
  opacity: 1;
  transform: none;
  transition: opacity 0.6s ease, transform 0.6s ease;
}
@media (prefers-reduced-motion: no-preference) {
  .scroll-reveal {
    opacity: 0;
    transform: translateY(24px);
  }
  .scroll-reveal.is-visible {
    opacity: 1;
    transform: none;
  }
  .scroll-reveal.delay-1 {
    transition-delay: 0.1s;
  }
  .scroll-reveal.delay-2 {
    transition-delay: 0.2s;
  }
}
.instagram-media {
  margin: 0 auto !important;
  min-width: 0 !important;
}
</style>
